import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDBigPicklistInput } from '@facet-wealth/design';
import Layout from './Layout';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('selectedAction', {
    _component: () => FDBigPicklistInput,
    _customProps: {
      helperText: '',
    },
  }, overrideReadOnly)
  .done();

const RoadmapHowToStartStepTemplate = ({ resource }) => {
  return (
    <MetaResourceRenderer
      layout={Layout}
      resource={resource}
      metaOverrideSet={metaOverrideSet}
    />
  );
};

RoadmapHowToStartStepTemplate.defaultProps = {
};

RoadmapHowToStartStepTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default RoadmapHowToStartStepTemplate;
